import {AbstractInteractionMode, DrawStyleUtil} from "./abstract-interaction-mode";
import {Feature} from "geojson";
import {v4 as uuid} from 'uuid';
import {MenuItem} from "primevue/menuitem";
import {MeasureSimpleSelect} from "../interaction/measure/measure-simple-select";
import {MeasureDrawLinestring} from "../interaction/measure/measure-draw-linestring";
import {MeasureDrawPolygon} from "../interaction/measure/measure-draw-polygon";
import {MapEvent} from "../../document/model/map";

export class MeasureMode extends AbstractInteractionMode {
  static identifier: string = "measure";
  static title: string = "Măsoară";
  static icon: string = "/icons/toolbox/measure.svg";
  static drawStyles = DrawStyleUtil.drawStyle({
    "line-width": 5
  });

  static isShowingActionBar(): boolean {
    return true;
  }

  static interactions = {
    'select': MeasureSimpleSelect.definition({selectionAllowed: true, multiSelection: true}),
    'draw_linestring': MeasureDrawLinestring.definition({changeset: 'draw_linestring'}),
    'draw_polygon': MeasureDrawPolygon.definition({changeset: 'draw_polygon'})
  };

  static defaultInteraction: string = 'draw_polygon';

  onInit() {
    if (this.controller.interaction.getFocused().length) {
      this.controller.interaction.setFocus([]);
    }
  }

  async onLayerGeometriesCreate(features: Feature[]) {
    features.forEach(feature => {
      feature.id = uuid();
      switch (feature.geometry.type) {
        case 'Polygon':
        case 'MultiPolygon':
          feature.properties._showArea = this.controller.interaction.hasArea();;
          feature.properties._showVertexLength = this.controller.interaction.hasVertexLength();;
          feature.properties._showLength = this.controller.interaction.hasLength();
          feature.properties._showAngle = this.controller.interaction.hasAngle();;
          break;
        case 'LineString':
        case 'MultiLineString':
          feature.properties._showLength = this.controller.interaction.hasLength();;
          feature.properties._showVertexLength = this.controller.interaction.hasVertexLength();;
          feature.properties._showAngle = this.controller.interaction.hasAngle();;
          break;
      }
    });

    this.controller.interaction.addTmpGeometries(features);
  }

  getGlobalActions(interactionIdentifier: string): MenuItem[] {
    return [
      {
        label: "Select",
        icon: "/icons/toolbox/editor-select.svg",
        active: interactionIdentifier === "select",
        command: () => {
          this.changeInteraction("select")
        },
        pos: { position: 'bottom' }
      },
      {
        label: "Area",
        icon: "/icons/toolbox/area.svg",
        command: () => this.changeInteraction("draw_polygon"),
        active: interactionIdentifier === "draw_polygon",
        pos: { position: 'bottom' }
      },
      {
        label: "Distance",
        icon: "/icons/toolbox/distance.svg",
        command: () => this.changeInteraction("draw_linestring"),
        active: interactionIdentifier === "draw_linestring",
        pos: { position: 'bottom' }
      },
    ];
  }
}
